export default __webpack_public_path__ + "static/logo-a9af1ca7b3b60e5b62933107f7b9cf73.png";